import createEditModal from 'components/EditModal/EditModal';

/**
 * Provides an editing modal that saves the resulting redux-form object back to the
 * widget's payload. The widget's payload will also be the default initial values for
 * the form.
 *
 * @param {(Object|function(props: Object, store: Object): Object)} modalPropsFn - the `TabbedModal` modal props or an object that returns them
 * @param {(Object[]|function(props: Object, store: Object): Object[])} tabsFn - an array of components to populate the tabs or a function that returns them
 * @returns {function(Component: Object): Object} the decorator or HOC to apply to the original component
 */
export default (modalPropsFn, tabsFn, { name, title } = {}) => Component => createEditModal({
  tabbedModalName: name || `${Component.manifestInfo.name}-widget-modal`,
  tabbedModalTitle: title || `${Component.manifestInfo.name} Settings`,
  modalPropsFn,
  tabsFn,
  Component,
});
